import { useState, useEffect } from "react";
import { 
  CircularProgress,
  Grid,
  Container,
  CssBaseline,
  Typography
} from '@material-ui/core';
import { useStyles } from "../Login/styles";
import { useLocation } from "react-router";
import { axiosHelper } from "utils/axios";
import { useHistory } from "react-router-dom";

const VerifyEmail = () => {
  const location = useLocation();
  const classes = useStyles();
  const [errorState, setError] = useState('');
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (token) {
      axiosHelper.post('/Users/verify-email', {
        "token": token
      }).then(() => {
        history.push('/login?verified=true');
      }).catch(() => {
        setError('Incorrect verification code, please check your email again');
      });
    }  
  }, [location.search, history]);

  return (
    <Container component="main" className={classes.loginWrapper}>
      <CssBaseline />
      <Grid xs={4} className={classes.accountCreatedWrapper}>
        <Grid className={classes.verificationMessage}>
          <Typography component="h1" variant="h5" className={classes.accountCreatedHeader}>
            Verifying Account
          </Typography>
          <Grid 
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ paddingTop: 50 }}
          >
            {errorState ? errorState : <CircularProgress />}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default VerifyEmail